import React from 'react';
import { CalendarDays } from 'lucide-react';
import './TimeframeToggle.css';

const TIMEFRAMES = [
  { value: 'today', label: 'Today' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
];

function TimeframeToggle({ value, onChange }) {
  return (
    <div className="timeframe-toggle">
      <CalendarDays size={16} className="timeframe-icon" />
      <div className="timeframe-pills">
        {TIMEFRAMES.map(({ value: tv, label }) => (
          <button
            key={tv}
            className={`timeframe-pill ${value === tv ? 'timeframe-pill-active' : ''}`}
            onClick={() => onChange(tv)}
            type="button"
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default TimeframeToggle;
